<template>
    <Icon 
        :icon="icon" 
        :inline="inline"
        :width="width"
        :height="height"
        :color="color"
        :rotate="rotate"
        :flip="flip"
        :horizontalFlip="horizontalFlip"
        :verticalFlip="verticalFlip"
        v-bind="$attrs"
        v-on="$listeners"
    />
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import { Icon } from '@iconify/vue2';

export default defineComponent({
    name: 'XIcon',
    components: {
        Icon
    },
    props: {
        // 图标名称（必填）
        // 例如: "mdi:home", "mdi-light:home", "flat-color-icons:voice-presentation"
        icon: {
            type: [String, Object] as PropType<string | object>,
            required: true
        },
        // 是否内联（改变垂直对齐方式）
        inline: {
            type: Boolean,
            default: false
        },
        // 图标宽度
        width: {
            type: [String, Number] as PropType<string | number>,
            default: undefined
        },
        // 图标高度
        height: {
            type: [String, Number] as PropType<string | number>,
            default: undefined
        },
        // 图标颜色
        color: {
            type: String,
            default: undefined
        },
        // 旋转角度（0, 90, 180, 270 或字符串 "90deg", "1", "2", "3"）
        rotate: {
            type: [Number, String] as PropType<number | string>,
            default: undefined
        },
        // 翻转方式（"horizontal", "vertical", "horizontal,vertical"）
        flip: {
            type: String,
            default: undefined
        },
        // 水平翻转
        horizontalFlip: {
            type: Boolean,
            default: false
        },
        // 垂直翻转
        verticalFlip: {
            type: Boolean,
            default: false
        }
    }
});
</script>

<style>
/* 默认设置为内联显示，与文字在同一行 */
.iconify {
    display: inline-block;
    vertical-align: middle;
}
</style>
